import TransCard from './TransCard.jsx';

export default TransCard;